<template>
    <section class="bos-grid">
        <div class="bos-card">
            <div class="bos-icon bos-icon--cyan"><i class="fal fa-layer-group"></i></div>
            <div class="bos-data">
                <div class="bos-value">{{ formTypes.length }}</div>
                <div class="bos-label">{{ $t('backoffice_infos.summary.form_types') }}</div>
            </div>
        </div>
        <div class="bos-card">
            <div class="bos-icon bos-icon--indigo"><i class="fal fa-file-alt"></i></div>
            <div class="bos-data">
                <div class="bos-value">{{ forms.length }}</div>
                <div class="bos-label">{{ $t('backoffice_infos.summary.forms') }}</div>
            </div>
        </div>
        <div class="bos-card">
            <div class="bos-icon bos-icon--green"><i class="fal fa-tasks"></i></div>
            <div class="bos-data">
                <div class="bos-value">{{ totalStatuses }}</div>
                <div class="bos-label">{{ $t('backoffice_infos.summary.statuses') }}</div>
            </div>
        </div>
        <div class="bos-card">
            <div class="bos-icon bos-icon--amber"><i class="fal fa-code-branch"></i></div>
            <div class="bos-data">
                <div class="bos-value">{{ totalDeployments }}</div>
                <div class="bos-label">{{ $t('backoffice_infos.summary.deployments') }}</div>
            </div>
        </div>
        <div class="bos-card">
            <div class="bos-icon bos-icon--purple"><i class="fal fa-ticket-alt"></i></div>
            <div class="bos-data">
                <div class="bos-value">{{ totalTickets }}</div>
                <div class="bos-label">{{ $t('backoffice_infos.summary.tickets') }}</div>
            </div>
        </div>
    </section>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    name: 'BackofficeSummary',
    props: {
        forms: { type: Array, required: true },
        formTypes: { type: Array, required: true }
    },
    computed: {
        totalStatuses() {
            return this.forms.reduce((sum, f) => sum + (f.statuses ? f.statuses.length : 0), 0)
        },
        totalDeployments() {
            return this.forms.reduce((sum, f) => sum + (f.deployments ? f.deployments.length : 0), 0)
        },
        totalTickets() {
            return this.forms.reduce((sum, f) => sum + (f.counts ? f.counts.posts : 0), 0)
        }
    }
}
</script>

<style scoped>
.bos-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: var(--v2-space-3);
}

.bos-card {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    padding: 16px 18px;
    display: flex;
    align-items: center;
    gap: 14px;
}

.bos-icon {
    width: 42px;
    height: 42px;
    border-radius: var(--v2-radius-md);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1.05rem;
}

.bos-icon--cyan { background: rgba(8, 145, 178, 0.1); color: #0891B2; }
.bos-icon--indigo { background: rgba(99, 102, 241, 0.1); color: #6366f1; }
.bos-icon--green { background: rgba(16, 185, 129, 0.1); color: #10b981; }
.bos-icon--amber { background: rgba(245, 158, 11, 0.1); color: #f59e0b; }
.bos-icon--purple { background: rgba(139, 92, 246, 0.1); color: #8b5cf6; }

.bos-data {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.bos-value {
    font-size: 1.4rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    line-height: 1.2;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.01em;
}

.bos-label {
    font-size: 0.72rem;
    color: var(--v2-text-3);
    font-weight: var(--v2-font-weight-semibold);
    text-transform: uppercase;
    letter-spacing: 0.02em;
    line-height: 1.2;
}

@media (max-width: 1200px) {
    .bos-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .bos-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 500px) {
    .bos-grid {
        grid-template-columns: 1fr;
    }
}
</style>
